import React from 'react';

import Typography from '../../../../library/typography/typography';
import { CheckCircleSolidIcon } from '../../../../shared/icons/icons';
import {
  PACKAGE_STATUS,
  STEP_TYPE
} from '../../tire-wheel-package-status-constants';

import './tire-wheel-package-status-item.scss';

interface TireWheelPackageStatusItemProps {
  count: number;
  status: 'COMPLETED' | 'IN_PROGRESS' | 'NOT_STARTED';
  type: 'TIRES' | 'WHEELS' | 'FINALIZE';
}

function TireWheelPackageStatusItem(props: TireWheelPackageStatusItemProps) {
  const { status, type, count } = props;

  const statusItemConfig = {
    [STEP_TYPE.TIRES]: {
      styleNames: {
        COMPLETED: 'inactive-step',
        IN_PROGRESS: 'active-step',
        NOT_STARTED: 'inactive-step'
      },
      text: 'Choose Tires'
    },
    [STEP_TYPE.WHEELS]: {
      styleNames: {
        COMPLETED: 'inactive-step',
        IN_PROGRESS: 'active-step',
        NOT_STARTED: 'inactive-step'
      },
      text: 'Choose Wheels'
    },
    [STEP_TYPE.FINALIZE]: {
      styleNames: {
        COMPLETED: 'active-finalize-step',
        IN_PROGRESS: 'active-finalize-step',
        NOT_STARTED: 'inactive-finalize-step'
      },
      text: 'Package Completed'
    }
  };

  if (!statusItemConfig[type]) {
    return null;
  }

  return (
    <div styleName="container">
      <div styleName="icon-container">
        {status === PACKAGE_STATUS.COMPLETED ? (
          <span styleName="completed-icon-wrapper">
            <CheckCircleSolidIcon styleName="completed-icon" />
          </span>
        ) : (
          <Typography
            styleName={`${statusItemConfig[type].styleNames[status]}`}
            tag="span"
            weight="black"
          >
            {count}
          </Typography>
        )}
      </div>
      <div className="display-sm">
        <Typography
          styleName={
            status !== PACKAGE_STATUS.NOT_STARTED
              ? 'completed-status'
              : 'inprogress-status'
          }
          tag="span"
          weight={status === PACKAGE_STATUS.IN_PROGRESS ? 'black' : 'normal'}
        >
          {statusItemConfig[type].text}
        </Typography>
      </div>
      <div className="hide-sm">
        <Typography
          size="small"
          styleName={
            status !== PACKAGE_STATUS.NOT_STARTED
              ? 'completed-status'
              : 'inprogress-status'
          }
          tag="span"
          weight={status === PACKAGE_STATUS.IN_PROGRESS ? 'black' : 'normal'}
        >
          {statusItemConfig[type].text}
        </Typography>
      </div>
    </div>
  );
}

export default TireWheelPackageStatusItem;
